/* eslint-disable local-rules/ordered-imports */
// @ts-strict-ignore
import './utils/honeycomb-observability';
import './utils/error-reporting';

import * as React from 'react';
import ReactDOM from 'react-dom/client';
import {RouterProvider} from 'react-router-dom';
import {getAppRouter} from '#iron/routes/router';
import {NuqsAdapter} from 'nuqs/adapters/react-router/v6';

document.addEventListener(`DOMContentLoaded`, () => {
  const appContainer = document.getElementById(`mixpanel-app-wrapper`);
  const root = ReactDOM.createRoot(appContainer);
  root.render(
    <React.StrictMode>
      <NuqsAdapter>
        <RouterProvider router={getAppRouter()} />
      </NuqsAdapter>
    </React.StrictMode>,
  );
});
